export default __webpack_public_path__ + "static/media/three.5f9c2340.jpeg";